import { useContext } from "react";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";
import { Image } from "capitalrx-components-2.0/lib/general";

import { ThemeSelectorContext } from "@/context/index";
import pillBottles from "@/static/images/pill_bottles.png";

import FindBestPriceSearch from "@/components/FindBestPriceSearch";

import styles from "./WhiteLabelHomeHero.module.scss";
import { getBrandLogo, getBrandName, getCardBrandText } from "@/utils/branding";

export const HomeHero = () => {
  const { clientDisplayName } = useContext(ThemeSelectorContext);
  const brandName = getBrandName();
  const cardBrandText = getCardBrandText("");
  const brandLogo = getBrandLogo();

  return (
    <div className={styles.WhiteLabelHomeHero}>
      <Shelf>
        <div className={styles.WhiteLabelHomeHeroImage}>
          <Image src={pillBottles} alt="image of pill bottles" />
        </div>
        <Stack spacing="medium-large" className={styles.WhiteLabelHomeHeroSearch}>
          <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
          <Heading level={1} className={styles.WhiteLabelHomeHeroHeading}>
            Save up to 90%
            <br />
            on your prescriptions *
          </Heading>
          <p className={styles.WhiteLabelHomeHeroSubHeading}>
            with the FREE <span className={styles.ClientName}>{clientDisplayName}</span>{" "}
            {cardBrandText}
          </p>
          <Stack>
            <FindBestPriceSearch />
            <Body className={styles.WhiteLabelHomeHeroPoweredBy}>
              Powered by <Image src={brandLogo} alt={`${brandName} Logo`} />
            </Body>
            <Body>
              *Based on the difference between the U&C submitted by the pharmacy and the price the
              patients pay
            </Body>
          </Stack>
        </Stack>
      </Shelf>
    </div>
  );
};
